<template>
  <div class="flex flex-1 flex-col">
    <div class="flex flex-1 px-4 py-12">
      <section class="mx-auto w-full max-w-3xl space-y-8">
        <div class="space-y-3 text-center">
          <h1 class="text-3xl font-semibold text-slate-900">Küsi pakkumist!</h1>
          <p class="text-sm text-slate-500">
            Jäta meile oma kontakt ja lühike kirjeldus soovitud rehvidest. Vastame nii kiiresti kui võimalik.
          </p>
        </div>

        <form
          @submit.prevent="createPost"
          class="rounded-3xl border border-slate-200 bg-white p-6 shadow-xl shadow-slate-900/5 sm:p-8"
        >
          <div class="space-y-6">
            <div class="space-y-2">
              <label for="header" class="text-sm font-semibold text-slate-700">
                Email
              </label>
              <textarea
                id="header"
                name="header"
                rows="2"
                required
                placeholder="nt. nimi@ettevote.ee"
                v-model.trim="header"
                class="w-full resize-none rounded-2xl border border-slate-200/80 bg-white px-4 py-3 text-sm text-slate-700 shadow-sm transition focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/30"
              ></textarea>
            </div>

            <div class="space-y-2">
              <label for="content" class="text-sm font-semibold text-slate-700">
                Kirja sisu
              </label>
              <textarea
                id="content"
                name="content"
                rows="6"
                required
                placeholder="Kirjelda, millist rehvilahendust vajad"
                v-model.trim="content"
                class="w-full rounded-2xl border border-slate-200/80 bg-white px-4 py-3 text-sm text-slate-700 shadow-sm transition focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/30"
              ></textarea>
            </div>
          </div>

          <div class="mt-8 flex flex-col items-center gap-3 sm:flex-row sm:justify-end">
            <button
              type="submit"
              class="inline-flex w-full items-center justify-center rounded-xl bg-brand px-6 py-3 text-sm font-semibold uppercase tracking-wide text-white shadow-lg shadow-brand/20 transition hover:bg-brand-dark focus:outline-none focus:ring-4 focus:ring-brand/40 sm:w-auto"
              :disabled="isSubmitDisabled"
              :class="{ 'opacity-60 cursor-not-allowed': isSubmitDisabled }"
            >
              Saada
            </button>
          </div>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddPostView",
  data: function () {
    return {
      content: "",
      header: "",
      isSubmitting: false,
    };
  },
  computed: {
    isSubmitDisabled() {
      return !this.header || !this.content || this.isSubmitting;
    },
  },
  methods: {
    async createPost() {
      if (this.isSubmitDisabled) return;
      this.isSubmitting = true;
      try {
        const response = await fetch("http://localhost:3000/api/posts", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({
            title: this.header,
            body: this.content,
          }),
        });
        if (!response.ok) {
          throw new Error(`Failed to submit form: ${response.status}`);
        }
        await response.json();
        this.$router.push("/");
      } catch (error) {
        console.error(error);
      } finally {
        this.isSubmitting = false;
      }
    },
  },
  mounted() {
    fetch(`http://localhost:3000/auth/authenticate`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => response.json())
      .then((data) => {
        if (!data.authenticated) {
          this.$router.push("/login");
        }
      })
      .catch((err) => console.log(err.message))
      .finally(() => {
        this.isSubmitting = false; // Reset the flag
      });
  },
};
</script>
